<template>
  <section class="py-4 py-md-5 about-section-bg">
    <div class="container">
      <!-- Section 1 -->
      <div class="row mb-5 flex-lg-row" v-if="section1">
        <div class="col-12 col-lg-6 mb-3 mb-lg-0">
          <img class="about-img shadow" loading="lazy" v-if="image1" :src="image1" alt="About 1">
        </div>
        <div class="col-12 col-lg-6">
          <div class="about-content-box p-4 rounded">
            <TitleArea :title="$t(section1Title)" v-if="section1Title"/>
            <!-- <h2 class="mb-3 boxTitle">{{ section1Title }}</h2> -->
            <p class="lead fs-5" v-html="section1"></p>
          </div>
        </div>
      </div>
      <!-- Section 2 -->
      <div class="row align-items-center mb-5 flex-lg-row-reverse" v-if="section2Content">
        <div class="col-12 col-lg-6 mb-3 mb-lg-0">
          <img class="about-img shadow" loading="lazy" v-if="image2" :src="image2" alt="About 2">
        </div>
        <!-- <div class="col-12 col-lg-6">
          <div class="about-content-box p-4 rounded">
             <TitleArea :title="$t(section2Title)" v-if="section2Title"/>
            <p class="lead fs-5" v-html="section2Content"></p>
          </div>
        </div> -->
      </div>
      <!-- Section 3 -->
      <div class="row align-items-center flex-lg-row" v-if="section3Content">
        <div class="col-12 col-lg-6 mb-3 mb-lg-0">
          <img class="about-img shadow" loading="lazy" v-if="image3" :src="image3" alt="About 3">
        </div>
        <div class="col-12 col-lg-6">
          <div class="about-content-box p-4 rounded">
            <TitleArea :title="$t(section3Title)" v-if="section3Title"/>
            <p class="lead fs-5" v-html="section3Content"></p>
          </div>
        </div>
      </div>
      <div class="row" v-if="this.administration">
          <div class="col-lg-4 offset-lg-8 col-md-6 card shadow-sm p-3 mb-5 bg-body rounded">
              <h4>{{administration.title}}</h4>
              <h5> {{administration.fullname}}<br></h5>
              <p> 
                  Tel:<a :href="'mailto:'+administration.tel">{{administration.tel}}</a><br>
                  Email:<a :href="'mailto:' + administration.email" v-html="administration.email"></a><br>
                  {{administration.address}}<br>
              </p>
          </div>
      </div>
    </div>
    
  </section>
</template>

<script>
import TitleArea from '@/components/share/TitleArea.vue';

export default {
  name: 'AboutSection',
  props: {
    image1: String,
    image2: String,
    image3:String,

    section1Title:String,
    section1: String,

    section2Title: String,
    section2Content: String,

    section3Title:String,
    section3Content:String,

    administration: {
      type: Object,
      required: false,
    }
  },
  components:{
    TitleArea
  }

}
</script>

<style scoped>
.about-section-bg {
  background: #f8f9fa;
}
.about-img {
  width: 100%;
  height: 350px;
  object-fit: container;
  border-radius: 16px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  box-shadow: 0 4px 24px rgba(0,0,0,0.08);
}
.about-content-box {
  background: #fff;
  box-shadow: 0 2px 16px rgba(0,0,0,0.04);
}
.text-primary {
  color: #1a237e;
}
@media (max-width: 991.98px) {
  .about-img {
    height: 220px;
  }
}

.boxTitle{
  color:#F5BD2A;
}
</style>
